import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import { CouponFormData } from "../schema/coupon-schema";
import { updateCoupon } from "../services/update-coupon";
import { getApiErrorMessage } from "@/helpers/get-api-error-message";

export function useUpdateCoupon() {
    const queryClient = useQueryClient();
    
    return useMutation({
      mutationFn: ({ id, data }: { id: string; data: Partial<CouponFormData> }) => 
        updateCoupon(id, data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["coupons"] });
        toast({ title: "Success", description: "Coupon updated successfully" });
      },
      onError: (error) => {
        toast({ title: "Error", description: getApiErrorMessage(error, "Failed to update coupon"), variant: "destructive" });
      },
    });
  }